'use strict';

var BaseStaticView = require('actions/shared/AbstractStaticView');
var tpl = require('actions/wanDns/static.html');
var twig = require('twig').twig;

/**
 * Renders a text-only version of the "VLAN WAN DNS" component.
 */
module.exports = BaseStaticView.extend({
  /**
   * @name actions/wanDns/StaticView#model
   * @type {actions/wanDns/EditWanDns}
   */

  template: twig({data: tpl}),
});
